import { Injectable } from '@angular/core';
import { AsyncLocalStorage } from 'angular-async-local-storage';

@Injectable()
export class SessionService {
    constructor(
        protected localStorage: AsyncLocalStorage,
    ){ }

    setData(data){
        return new Promise((resolve, reject) => {
            try{
                for(let key in data){
                    sessionStorage.setItem(key, data[key]);
                }
                resolve();
            }catch(err){
                reject();
            }
        });
    }

    getData(key) {
        return sessionStorage.getItem(key);
    }

    deleteData(){
        return new Promise((resolve, reject) => {
            try{
                sessionStorage.clear();
                resolve();
            }catch(err){
                reject(err);
            }
        });
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/services/session.service.ts